import type React from 'react';
import { observer } from 'mobx-react';
import { Box, ButtonLink, IconNewWindow } from 'braid-design-system';

import { trackTalentSearchLinkOutClickEvent } from 'src/utils/events';

import { useStores } from 'src/utils/hooks/useStores';
import type { IJobStore } from 'src/stores/JobStore';
import translations from './.vocab/';
import { useTranslations } from '@vocab/react';
import { useAppConfig } from 'src/constants/AppConfig/AppConfigProvider';

const TalentSearchLink: React.FC = () => {
  const { t } = useTranslations(translations);
  const { jobStore, seekAdvertiserId } = useStores();
  const { job } = jobStore as IJobStore;
  const { router } = useAppConfig();

  const trackTalentSearchExitLinkClick = () => {
    trackTalentSearchLinkOutClickEvent({
      isExitLink: '1',
    });
  };

  return (
    <Box data={{ intercomid: 'talentSearchLink' }}>
      <ButtonLink
        target="_blank"
        rel="noopener"
        variant="transparent"
        href={
          job.jobInformation.jobId !== null
            ? router.talentSearchForJob({
                jobId: job.jobInformation.jobId,
                seekAdvertiserId,
              })
            : ''
        }
        onClick={trackTalentSearchExitLinkClick}
        role="button"
      >
        <IconNewWindow /> {t('Talent Search')}
      </ButtonLink>
    </Box>
  );
};

export default observer(TalentSearchLink);
